module.exports = __webpack_public_path__ + "static/img/red_04_405.1af026e.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/recruit/2025/teaser/deco/red_04_405.png
// module id = LNLo
// module chunks = 0